<template>
  <BookingsContainer />
</template>

<script lang="ts">
import Vue from "vue";
import BookingsContainer from "@/components/projects/project/bookings/container/BookingsContainer.vue";

export default Vue.extend({
  components: {
    BookingsContainer,
  },
});
</script>
